export enum DeliveryStatus {
  OnTheWay = "OnTheWay",
  Delivered = "Delivered",
  Failed = "Failed"
}

export const DELIVERY_STATUSES_LIST = [
  {
    label: "On the Way",
    value: DeliveryStatus.OnTheWay,
    backgroundColor: "#FF9900"
  },
  {
    label: "Delivered",
    value: DeliveryStatus.Delivered,
    backgroundColor: "#16C350"
  },
  {
    label: "Failed",
    value: DeliveryStatus.Failed,
    backgroundColor: "#FF0033"
  }
];
